/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_115_TitleInputs */

const en_tree_type_115_title = /** @type {(inputs: Tree_Type_115_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moth Orchid`)
};

const ar_tree_type_115_title = /** @type {(inputs: Tree_Type_115_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زهرة الأوركيد`)
};

const de_tree_type_115_title = /** @type {(inputs: Tree_Type_115_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mottenorchidee`)
};

const es_tree_type_115_title = /** @type {(inputs: Tree_Type_115_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orquídea polilla`)
};

const fr_tree_type_115_title = /** @type {(inputs: Tree_Type_115_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orchidée Papillon`)
};

const it_tree_type_115_title = /** @type {(inputs: Tree_Type_115_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orchidea Falenopsis`)
};

const ja_tree_type_115_title = /** @type {(inputs: Tree_Type_115_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`胡蝶蘭`)
};

const ko_tree_type_115_title = /** @type {(inputs: Tree_Type_115_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나방 난초`)
};

const pt_br_tree_type_115_title = /** @type {(inputs: Tree_Type_115_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orquídea Mariposa`)
};

const ru_tree_type_115_title = /** @type {(inputs: Tree_Type_115_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фаленопсис`)
};

const th_tree_type_115_title = /** @type {(inputs: Tree_Type_115_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กล้วยไม้ผีเสื้อราตรี`)
};

const tr_tree_type_115_title = /** @type {(inputs: Tree_Type_115_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ay Orkidesi`)
};

const zh_cn_tree_type_115_title = /** @type {(inputs: Tree_Type_115_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`蝴蝶兰`)
};

const zh_tw_tree_type_115_title = /** @type {(inputs: Tree_Type_115_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`蝴蝶蘭`)
};

/**
* | output |
* | --- |
* | "Moth Orchid" |
*
* @param {Tree_Type_115_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_115_title = /** @type {((inputs?: Tree_Type_115_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_115_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_115_title(inputs)
	if (locale === "ar") return ar_tree_type_115_title(inputs)
	if (locale === "de") return de_tree_type_115_title(inputs)
	if (locale === "es") return es_tree_type_115_title(inputs)
	if (locale === "fr") return fr_tree_type_115_title(inputs)
	if (locale === "it") return it_tree_type_115_title(inputs)
	if (locale === "ja") return ja_tree_type_115_title(inputs)
	if (locale === "ko") return ko_tree_type_115_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_115_title(inputs)
	if (locale === "ru") return ru_tree_type_115_title(inputs)
	if (locale === "th") return th_tree_type_115_title(inputs)
	if (locale === "tr") return tr_tree_type_115_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_115_title(inputs)
	return zh_tw_tree_type_115_title(inputs)
});